// extracted by mini-css-extract-plugin
export default {"button":"customButton_button__53Dj9","disabled":"customButton_disabled__8kAxZ"};